<script lang="ts" setup>
  import Divider from '@leaflink/stash/Divider.vue';
  import Icon from '@leaflink/stash/Icon.vue';
  import RadioGroup from '@leaflink/stash/RadioGroup.vue';
  import RadioNew from '@leaflink/stash/RadioNew.vue';
  import { onBeforeMount, ref } from 'vue';
  import { I18nT } from 'vue-i18n';

  import CategoryManagementInterestModal from '@/components/CategoryManagement/CategoryManagementInterestModal.vue';
  import { useFeatureEnrollmentProvider } from '@/components/FeatureEnrollment/FeatureEnrollmentLayout.vue';
  import i18n from '@/plugins/i18n';
  import { trackWithSegment } from '@/segment';

  import ConnectingPOSInfo from '../components/ConnectingPOSInfo.vue';
  import { useInventoryInsightsProvider } from '../InventoryInsights.vue';

  const { productName, isAdmin, isPosApiEnabled, selectedPosSystem } = useInventoryInsightsProvider();
  const { currentStep, isNavForwardDisabled } = useFeatureEnrollmentProvider();

  const showModal = ref(false);

  const handleJoiningWaitlist = () => {
    showModal.value = true;

    trackWithSegment({
      event: 'inventoryInsightsEnrollmentWaitlistClicked',
      properties: {
        product_name: productName,
        element_engaged: 'Join the Waitlist link',
        page_engaged_from: currentStep.value?.text,
      },
    });
  };

  onBeforeMount(() => {
    isNavForwardDisabled.value = !isAdmin.value || isPosApiEnabled.value;
  });
</script>

<template>
  <div class="tw-flex-1 tw-bg-white tw-text-ice-900">
    <h3 class="tw-mb-2">
      {{ i18n.t('inventoryInsights.inventoryInsightsIntegration') }}
    </h3>

    <Divider class="tw-mb-8" />

    <p>{{ i18n.t('inventoryInsights.getStarted') }}</p>

    <div class="tw-mb-[18px] tw-flex tw-items-center">
      <RadioGroup v-model="selectedPosSystem" variant="chip">
        <RadioNew id="dutchie" label="Dutchie" value="dutchie" />
        <RadioNew id="flowhub" label="Flowhub" value="flowhub" />
      </RadioGroup>
    </div>

    <ConnectingPOSInfo class="tw-mb-[18px] tw-bg-ice-100 tw-p-[18px] tw-shadow-md" />

    <p class="tw-mb-0">{{ i18n.t('inventoryInsights.notSeeingPOS.title') }}</p>

    <I18nT keypath="inventoryInsights.notSeeingPOS.description" scope="global" tag="span" class="tw-text-ice-700">
      <template #link>
        <a href="#" class="tw-text-blue-500 tw-underline" @click.prevent="handleJoiningWaitlist">
          {{ i18n.t('inventoryInsights.notSeeingPOS.linkLabel') }}
        </a>
      </template>
    </I18nT>

    <div class="tw-pt-2">
      <h3 class="tw-mb-2">{{ i18n.t('inventoryInsights.billingInformation') }}</h3>
      <Divider class="tw-mb-6" />
      <div class="tw-flex tw-items-center">
        <Icon class="tw-mr-1 tw-text-ice-700" name="money" dense />
        <p class="tw-mb-0 tw-mt-1">{{ i18n.t('inventoryInsights.billingInformationDescription') }}</p>
      </div>
    </div>

    <Teleport to="#stash-modals-mount-node">
      <CategoryManagementInterestModal
        v-if="showModal"
        :source="'inventory-insights-enrollment'"
        @close="showModal = false"
      />
    </Teleport>
  </div>
</template>
